export class ApiError extends Error {
    constructor(public httpStatus: number, public message: string) { super(message) }
}